import { useState, useEffect } from "react";
import { saveBankDetails, getAllCompanyCodes } from "../Api/BankMaster";
import { Container, Form, Button, Row, Col, Accordion, AccordionItem, AccordionBody } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";
import "../Styling/ResetButton.css";

const BankMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [companyCodes, setCompanyCodes] = useState([]);

  const [bankData, setBankData] = useState({
    code: "",
    description: "",
    companyCode: ""
  });

  useEffect(() => {
    const fetchCompanyCodes = async () => {
      try {
        const data = await getAllCompanyCodes();
        setCompanyCodes(data);
      } catch (error) {
        toast.error("Failed to load company codes");
      }
    };
    fetchCompanyCodes();
  }, []);

  const handleChange = (e) => {
    setBankData({ ...bankData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveBankDetails(bankData);
      toast.success("Bank Added Successfully");
      setBankData({ code: "", description: "", companyCode: "" });
      navigate("/viewBankMaster");
    } catch (error) {
      toast.error("Error adding bank!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container bank-master-fields">

        <h2 className="fields-title">Bank Master</h2>

        <Form onSubmit={handleSubmit} className="fields-form">

          <Accordion defaultActiveKey="0">
            <AccordionItem eventKey="0">
              <AccordionBody>

                <Row className="g-3">

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group controlId="code">
                      <Form.Label>
                        Bank Code <span className="text-red">**</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="code"
                        value={bankData.code}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group controlId="description">
                      <Form.Label>
                        Description <span className="text-red">**</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="description"
                        value={bankData.description}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group controlId="companyCode">
                      <Form.Label>
                        Company Code <span className="text-red">**</span>
                      </Form.Label>

                      <Form.Select
                        name="companyCode"
                        value={bankData.companyCode}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Company Code</option>

                        {companyCodes.map((company) => (
                          <option
                            key={company.companyCode}
                            value={company.companyCode}
                          >
                            {company.companyCode} - {company.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                </Row>

              </AccordionBody>
            </AccordionItem>
          </Accordion>

          <div className="fields-btn-container" style={{ marginTop: "16px" }}>

            <Button
              type="button"
              className="fields-reset"
              onClick={() =>
                setBankData({ code: "", description: "", companyCode: "" })
              }
            >
              Reset
            </Button>

            <Button
              type="submit"
              className="fields-submit"
            >
              Save
            </Button>

          </div>

        </Form>
      </div>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default BankMaster;